module.exports = __webpack_public_path__ + "img/Jey8DRSC2T1635155480914.00c3c7df.jpg";